import React, { Component } from 'react';
import API from '../../services/API';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Icon from '../../components/Icon';
import OffersTable from './components/OffersTable';
import Form from './components/Form';
import PercentageForm from './components/PercentageForm';
import FactorForm from './components/FactorForm';
import CountriesForm from './components/CountriesForm';
import CpcForm from './components/CpcForm';

class Filler extends Component {
    constructor() {
        super();

        this.state = {
            offers: [],
            countries: [],
            cpc: {},
            percentage: null,
            factor: null,
            isLoading: false,
            isShowForm: false,
            isShowCpcForm: false,
            selectedOffer: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleCpcFormHide = this.handleCpcFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handlePercentageFormSubmit = this.handlePercentageFormSubmit.bind(this);
        this.handleFactorFormSubmit = this.handleFactorFormSubmit.bind(this);
        this.handleCountriesFormSubmit = this.handleCountriesFormSubmit.bind(this);
        this.handleCpcFormSubmit = this.handleCpcFormSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleDuplicate = this.handleDuplicate.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleCpcClick = this.handleCpcClick.bind(this);
    }

    componentDidMount() {
        this.loadOffers();
        this.loadCountries();
        this.loadPercentage();
        this.loadCpc();
        this.loadFactor();
    }

    loadOffers() {
        this.setState({ isLoading: true });

        API.Filler.Offers.get()
            .then(({ offers }) => this.setState({ offers,  isLoading: false }));
    }

    loadCountries() {
        this.setState({ isLoading: true });

        API.Filler.Countries.get()
            .then(({ countries }) => this.setState({ countries,  isLoading: false }));
    }

    loadPercentage() {
        this.setState({ isLoading: true });

        API.Filler.Percentage.get()
            .then(({ percentage }) => {
                this.setState({ percentage,  isLoading: false })
            });
    }

    loadFactor() {
        this.setState({ isLoading: true });

        API.Filler.Factor.get()
            .then(({ factor }) => {
                this.setState({ factor,  isLoading: false })
            });
    }

    loadCpc() {
        this.setState({ isLoading: true });

        API.Filler.Cpc.get()
            .then(({ cpc }) => this.setState({ cpc,  isLoading: false }));
    }


    getForm() {
        if(this.state.isShowForm) {
            return (
                <Form
                    onFormHide={this.handleFormHide}
                    onSubmit={this.handleFormSubmit}
                    offer={this.state.selectedOffer}
                />
            );
        }
    }

    getCpcForm() {
        if(this.state.isShowCpcForm) {
            return (
                <CpcForm
                    onFormHide={this.handleCpcFormHide}
                    onSubmit={this.handleCpcFormSubmit}
                    cpc={this.state.cpc}
                />
            );
        }
    }

    handleAddBtnClick() {
        this.setState({
            isShowForm: true,
            selectedOffer: null,
            action: 'save'
        });
    }

    handleUpdate(offerID) {
        const offer = this.state.offers.find(item => item.id === offerID);
        this.setState({
            isShowForm: true,
            selectedOffer: offer,
            action: 'update'
        });
    }

    handleDuplicate(offerID) {
        const offer = this.state.offers.find(item => item.id === offerID);
        this.setState({
            isShowForm: true,
            selectedOffer: offer,
            action: 'save'
        });
    }

    handleRemove(offerID) {
        this.setState({
            isLoading: true
        });

        API.Filler.Offers.remove(offerID).then(() => {
            let { offers } = this.state;
            offers = offers.filter(item => !(item.id === offerID));


            this.setState({
                isLoading: false,
                offers
            });
        });
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['bidder'], 'filler', 8081)
            .then(() => this.setState({ isLoading: false }));
    }

    handleFormHide() {
        this.setState({
            isShowForm: false
        });
    }

    handleCpcFormHide() {
        console.log('FORM_HIDE');
        this.setState({
            isShowCpcForm: false
        });
    }

    handleFormSubmit({ id, ...offer }) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });

        if(this.state.action === 'update') {
            API.Filler.Offers.update(id, offer).then(() => this.loadOffers());
        }
        else {
            API.Filler.Offers.save(offer).then(() => this.loadOffers());
        }
    }

    handleCpcFormSubmit(cpc) {
        this.setState({
            isShowCpcForm: false,
            isLoading: true
        });

        API.Filler.Cpc.save(cpc).then(() => this.loadCpc());
    }

    handlePercentageFormSubmit(percentage) {
        this.setState({ isLoading: true });

        API.Filler.Percentage.save(percentage)
            .then(() => this.loadPercentage())
    }

    handleFactorFormSubmit(factor) {
        this.setState({ isLoading: true });

        API.Filler.Factor.save(factor)
            .then(() => this.loadFactor())
    }

    handleCountriesFormSubmit(countries) {
        this.setState({ isLoading: true });

        API.Filler.Countries.save(countries)
            .then(() => this.loadCountries())
    }

    handleCpcClick() {
        this.setState({ isShowCpcForm: true });
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Filler"/>
                <Row>
                    <Col lg={12}>
                        <Button className="pull-right m-b-15 m-r-15" bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        <Button bsStyle="info" onClick={this.handleCpcClick}>CPC</Button>
                    </Col>
                </Row>
                <PercentageForm percentage={this.state.percentage} onSubmit={this.handlePercentageFormSubmit}/>
                <FactorForm factor={this.state.factor} onSubmit={this.handleFactorFormSubmit}/>
                <CountriesForm countries={this.state.countries} onSubmit={this.handleCountriesFormSubmit}/>
                <Row>
                    <Col lg={12}>
                        <Button className="pull-right m-b-15" bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                    </Col>
                </Row>
                {this.getForm()}
                {this.getCpcForm()}
                <OffersTable
                    offers={this.state.offers}
                    onUpdate={this.handleUpdate}
                    onDuplicate={this.handleDuplicate}
                    onRemove={this.handleRemove}
                />
            </Container>
        );
    }
}

export default Filler;


// WEBPACK FOOTER //
// ./src/scenes/Filler/index.js